import React from 'react';
// import { EmptyMessageCardIcon } from '../../icon';
import EmptyMessageCardIcon from '../../icons/empty-message-cards-icon.svg'

interface Props {
    label: string
}

const BlankConvCard = (props: Props) => {
    return (
        <div className='d-flex flex-direction my-auto'>
            <div className='mx-auto'>
                <img src={EmptyMessageCardIcon} alt={"empty message cards"} />
            </div>
            <div className='color-conv-hist-date h6-regular mx-auto my-2'>
                You don't have any {props.label !== "All" && props.label.toLowerCase()} messages
            </div>
        </div>
    )
}

export default BlankConvCard